import { Injectable } from '@angular/core';
import { IncidentServiceBase } from '../services/incident-base.service';
import { NsfIncidentModel } from '../models/nsf-incident.model';

@Injectable()
export class NsfIncidentService extends IncidentServiceBase<NsfIncidentModel> {
    constructor() {
        super('NsfIncident', () => new NsfIncidentModel());
    }
}
